import * as types from './types'
import { AnyAction } from 'redux'
import { IThemeFormValues } from '../components/ThemeForm'

const defaultThemeState = null

const theme = (state: IThemeFormValues | null = defaultThemeState, action: AnyAction) => {
  switch (action.type) {
    case types.GET_THEME_SUCCESS:
      return action.payload.data.Data as IThemeFormValues
    case types.RESET_THEME_STATE:
      return defaultThemeState
    default:
      return state
  }
}

export default theme
